(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deliang-customization"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('dl-customizer')) {
  customElements.define('dl-customizer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.form = this.querySelector('form');
      if (!this.form || !this.querySelector('[data-details]')) {
        if (!this.waitForChildren) {
          this.waitForChildren = new MutationObserver(() => this.connectedCallback());
          this.waitForChildren.observe(this, {childList:true,subtree:true});
        }
        return;
      }
      if (this.waitForChildren) this.waitForChildren.disconnect();
      this.initialized = true;
      this.qty = this.querySelector('[data-quantity]');
      this.pantone = this.querySelector('[data-pantone]');
      this.details = this.querySelector('[data-details]');
      this.storeKey = 'dlc-selection:' + location.pathname + ':' + this.id;
      this.restore();
      this.form.addEventListener('input', () => { this.update(); this.remember(); });
      this.form.addEventListener('change', () => { this.update(); this.remember(); });
      this.form.addEventListener('submit', () => { this.update(); this.remember(); });
      this.querySelectorAll('[data-detail]').forEach(button => button.addEventListener('click', () => {
        const text = button.dataset.detail + ': ';
        if (!this.details.value.includes(text)) this.details.value += (this.details.value ? '\n' : '') + text;
        this.querySelector('.dl-inquiry').scrollIntoView({block:'start',behavior:'auto'});
        this.details.focus({preventScroll:true});
        this.update();
      }));
      this.querySelectorAll('[data-chat]').forEach(link => link.addEventListener('click', event => {
        this.update();
        if (!this.qty.checkValidity()) { event.preventDefault(); this.qty.reportValidity(); return; }
        if (!/^\d{7,15}$/.test(this.phone())) {
          event.preventDefault();
          const message = this.querySelector('[data-local-message]');
          message.hidden = false;
          message.textContent = this.dataset.unavailable;
          message.scrollIntoView({block:'center',behavior:'auto'});
        }
      }));
      this.update();
      const success = this.querySelector('[data-success]');
      if (success) { try { sessionStorage.removeItem(this.storeKey); } catch {} }
    }
    choice(attribute) { return this.querySelector('input[' + attribute + ']:checked'); }
    phone() { return (this.dataset.whatsapp || '').replace(/\D/g,''); }
    update() {
      const shape = this.choice('data-form');
      const material = this.choice('data-material');
      const color = this.choice('data-color');
      if (!shape || !material || !color) return;
      const isCustom = color.dataset.color === 'custom';
      this.querySelector('[data-pantone-panel]').hidden = !isCustom;
      this.pantone.disabled = !isCustom;
      this.dataset.activeForm = shape.dataset.form;
      const colorText = color.dataset.label + (isCustom && this.pantone.value.trim() ? ' · ' + this.pantone.value.trim() : '');
      this.querySelector('[data-summary-form]').textContent = shape.dataset.label;
      this.querySelector('[data-summary-material]').textContent = material.dataset.label;
      this.querySelector('[data-summary-color]').textContent = colorText;
      this.querySelector('[data-current-color]').textContent = colorText;
      this.querySelector('[data-material-info]').textContent = material.dataset.description;
      this.querySelector('[data-form-summary]').textContent = [shape.dataset.label, material.dataset.label, colorText, this.qty.checkValidity() ? this.qty.value : this.dataset.quantityNeeded].join(' · ');
      const lines = [this.dataset.chatIntro, '', 'Form: ' + shape.value, 'Material: ' + material.value, 'Color: ' + color.value];
      if (isCustom && this.pantone.value.trim()) lines.push('Pantone: ' + this.pantone.value.trim());
      lines.push('Quantity: ' + this.qty.value);
      const country = this.form.elements.namedItem('contact[Country]');
      if (country && country.value.trim()) lines.push('Destination: ' + country.value.trim());
      if (this.details.value.trim()) lines.push('Details: ' + this.details.value.trim());
      lines.push('', this.dataset.chatEnd);
      const url = 'https://wa.me/' + this.phone() + '?text=' + encodeURIComponent(lines.join('\n'));
      this.querySelectorAll('[data-chat]').forEach(link => { link.href = url; });
    }
    remember() {
      const data = {};
      ['data-form','data-material','data-color'].forEach(key => { const input=this.choice(key); if(input)data[key]=input.value; });
      data.quantity=this.qty.value; data.pantone=this.pantone.value;
      try { sessionStorage.setItem(this.storeKey,JSON.stringify(data)); } catch {}
    }
    restore() {
      if(this.querySelector('[data-success]')) return;
      try {
        const data=JSON.parse(sessionStorage.getItem(this.storeKey) || 'null');
        if (!data || typeof data !== 'object') return;
        ['data-form','data-material','data-color'].forEach(key => this.querySelectorAll('input['+key+']').forEach(input => { if(input.value===data[key])input.checked=true; }));
        if (/^[1-9]\d{0,5}$/.test(String(data.quantity))) this.qty.value=String(data.quantity);
        if(typeof data.pantone==='string') this.pantone.value=data.pantone.slice(0,80);
      } catch {}
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
